<template>
  <div>
    <vxe-grid
      border
      auto-resize
      resizable
      highlight-hover-row
      :data="data"
      :columns="tableColumns"
      :height="300"
      size="small"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
}
</script>
